import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPasswordSentMessage from './ForgotPasswordSentMessage';
import { Icon, Row, Text } from '../../../../common';
import { useAuthorization } from '../../sagas';

import './styles.less';

const ForgotPassword = props => {
  const { t } = useTranslation();
  const { onBackClick } = props;
  const { sendRecovery, isLoading } = useAuthorization();
  const [isSent, setIsSent] = useState(false);

  const handleForgotPassword = useCallback(
    values => {
      sendRecovery(
        values,
        () => setIsSent(true)
      );
    },
    [sendRecovery, setIsSent]
  );

  return (
    <div className="forgot-password-container">
      <Row justify="space-between" mb={20}>
        <button
          type="button"
          onClick={onBackClick}
          aria-label="back"
          style={{
            cursor: 'pointer',
            background: 'transparent',
            border: 'none',
            padding: 0,
            display: 'inline-flex'
          }}
        >
          <Icon name="back" size={24} color="#f5f5f5" />
        </button>
        <Text h2 white upper>
          {t`Forgot password`}
        </Text>
        <div />
      </Row>
      {!isSent && (
        <ForgotPasswordForm
          onSubmit={handleForgotPassword}
          loading={isLoading}
        />
      )}
      {isSent && <ForgotPasswordSentMessage />}
    </div>
  );
};

ForgotPassword.propTypes = {};

export default ForgotPassword;